module.exports = __webpack_public_path__ + "img/압구정역 미용실.c94a91d0.png";